import { Timeslot } from '@griply/types';

export type TimeslotRange = {
  startDate: Date;
  endDate: Date | null;
};

/**
 * Converts a Timeslot's `startTime` (milliseconds since midnight) + `duration` (ms)
 * into Date objects anchored at an arbitrary same-day reference. Returns null when
 * no time is set.
 */
export const computeTimeslotRange = (
  timeslot: Timeslot | null | undefined,
): TimeslotRange | null => {
  if (
    !timeslot ||
    timeslot.startTime === undefined ||
    timeslot.startTime === null
  ) {
    return null;
  }

  const startDate = new Date();
  startDate.setHours(0, 0, 0, timeslot.startTime);

  if (!timeslot.duration) {
    return { startDate, endDate: null };
  }

  const endDate = new Date();
  endDate.setHours(0, 0, 0, timeslot.startTime + timeslot.duration);

  return { startDate, endDate };
};
